export const getCustomers = (state) => state.customers.list;
export const getPlatform = (state) => state.customers.platform;